import React from 'react';
import { Image_Url } from '../../../constants/imageUrl/ImageUrl';

function ImageModal({ isOpen, onClose, imageSrc, currentWidth = 200 }) {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className='popup-images'>
        <img
          src={Image_Url.CROSSC}
          className='zoominoutimgcross'
          onClick={onClose}
          alt="Close"
        />
        <img
          alt="img"
          className='large-image'
          width={currentWidth}
          src={imageSrc}
        />
      </div>
    </div>
  );
}

export default ImageModal;
